import { Command } from './Command';
import { ChartEngine, Region } from '../core/ChartEngine';

export class AddRegionCommand implements Command {
  constructor(private regionData: Omit<Region, 'layers'>) {}
  execute(engine: ChartEngine) { engine.addRegion(this.regionData); }
  undo(engine: ChartEngine) { engine.removeRegion(this.regionData.id); }
}

export class RemoveRegionCommand implements Command {
  private savedRegion: Omit<Region, 'layers'> | null = null;
  constructor(private regionId: string) {}
  execute(engine: ChartEngine) {
    const region = engine.getSnapshot().find(r => r.id === this.regionId);
    if (region) {
      const { layers, ...rest } = region;
      this.savedRegion = rest;
      engine.removeRegion(this.regionId);
    }
  }
  undo(engine: ChartEngine) {
    if (this.savedRegion) engine.addRegion(this.savedRegion);
  }
}